import qs from 'query-string';

import { APP_MULTI_IFRAME_ROUTER_PARAM, APP_ROUTER_PARAM } from '../constants/router';

import { getEscapedFolderName } from './embedCodeParams';
import { getHashLocation } from './history';
import logger from './logger';

export const isWatchInIframe = window.self !== window.top;

// https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
let isInSameDomain$: boolean;
try {
  isInSameDomain$ = !!window.top?.history;
} catch {
  isInSameDomain$ = false;
}
export const isInSameDomain = isInSameDomain$;

export type SearchQueryParams = Record<string, string | Record<string, string>>;

export const getUpdatedIframeRoute = (searchQuery: SearchQueryParams): SearchQueryParams => ({
  [APP_MULTI_IFRAME_ROUTER_PARAM]: searchQuery[APP_MULTI_IFRAME_ROUTER_PARAM],
});

const getQueryParams = (): SearchQueryParams => {
  const window$ = window.top || window;
  const parentQuery = qs.parse(window$.location.search) as Record<string, string>;

  return {
    ...parentQuery,
    [APP_MULTI_IFRAME_ROUTER_PARAM]: parentQuery[APP_MULTI_IFRAME_ROUTER_PARAM]
      ? (qs.parse(parentQuery[APP_MULTI_IFRAME_ROUTER_PARAM]) as Record<string, string>)
      : {},
  };
};

export const tryPresetInIframeRouter = (): void => {
  const queries = getQueryParams();
  const hubQuery = (queries[APP_MULTI_IFRAME_ROUTER_PARAM] as Record<string, string>)[getEscapedFolderName()];

  if (hubQuery && /^#/.test(hubQuery)) {
    const { pathname, search } = window.location;

    window.history.replaceState({}, '', `${pathname}${search}#${hubQuery}`);
  }
};

export const updateIframeRouter = (hash: string): void => {
  logger.log('Update in iframe router');

  const { pathname, search } = getHashLocation(hash);
  const queryParams = getQueryParams();

  const locationHash = `#${pathname}${search ? `?${search}` : ''}`;
  const compareHash = (queryParams[APP_MULTI_IFRAME_ROUTER_PARAM] as Record<string, string>)[getEscapedFolderName()];

  const compareHashFixed = (compareHash || '').replace(/#\//, '');
  const locationHashFixed = (locationHash || '').replace(/#\//, '');

  if (compareHashFixed !== locationHashFixed) {
    delete (queryParams[APP_MULTI_IFRAME_ROUTER_PARAM] as Record<string, string>)[getEscapedFolderName()];

    if (locationHashFixed) {
      (queryParams[APP_MULTI_IFRAME_ROUTER_PARAM] as Record<string, string>)[getEscapedFolderName()] = locationHash;
    }

    const isQueryEmpty = !Object.keys(queryParams[APP_MULTI_IFRAME_ROUTER_PARAM] as Record<string, string>).length;

    if (!isQueryEmpty) {
      queryParams[APP_MULTI_IFRAME_ROUTER_PARAM] = qs.stringify(
        queryParams[APP_MULTI_IFRAME_ROUTER_PARAM] as Record<string, string>,
      );
    } else {
      delete queryParams[APP_MULTI_IFRAME_ROUTER_PARAM];
    }

    const rq = qs.stringify(queryParams);
    const { location, history: parentWindowHistory } = window.top || window;
    const newUrl = `${location.origin}${location.pathname}${rq ? `?${rq}` : ''}${location.hash}`;

    parentWindowHistory.replaceState({ path: newUrl }, '', newUrl);
  }
};

export const tryPresetSocialRouter = (): void => {
  const searchQuery = qs.parse(window.location.search) as Record<string, string>;
  const lwRouter = searchQuery[APP_ROUTER_PARAM];

  if (lwRouter) {
    delete searchQuery[APP_ROUTER_PARAM];

    const { href } = window.location;
    const search = qs.stringify(searchQuery);

    window.history.replaceState({}, '', `${href.split(/[?#]/g).shift()}?${search}#${lwRouter.replace(/#/, '')}`);
  }
};
